import * as React from 'react';
import { Spring } from 'react-spring/renderprops.cjs';
import styled from 'styled-components';
import { theme } from '../theme';

const Container = styled.div`
  width: 100%;
  height: 100%;
  z-index: ${theme.zIndex[12]};
  max-height: 0;
  overflow: hidden;
`;

const OuterWrapper = styled.div`
  display: flex;
`;

const InnerWrapper = styled.div`
  width: 100%;
`;

type CollapseProps = {
  open: boolean;
  collapsedHeight?: number;
  children: React.ReactNode;
  style?: any;
};

class Collapse extends React.Component<CollapseProps, {}> {
  static defaultProps = {
    collapsedHeight: 0,
    open: false,
  };

  private outerWrapper: any = React.createRef<HTMLDivElement>();

  render() {
    const { children, open, style } = this.props;
    const node = this.outerWrapper.current;
    const outerWrapperHeight = node ? node.clientHeight : 0;
    // TODO: Add easing function.
    return (
      <Spring
        config={{ tension: 200, friction: 30 }}
        from={{ maxHeight: !open ? outerWrapperHeight : 0 }}
        to={{ maxHeight: !open ? 0 : outerWrapperHeight }}
      >
        {styleProps => (
          <Container style={{ ...styleProps, ...style }}>
            <OuterWrapper ref={this.outerWrapper}>
              <InnerWrapper>{children}</InnerWrapper>
            </OuterWrapper>
          </Container>
        )}
      </Spring>
    );
  }
}

export default Collapse;



// WEBPACK FOOTER //
// ./src/components/Collapse.tsx